/**
 * Hook for fetching bill queries using clean architecture
 * @param documentId - Bill document ID
 */
import { useQueriesBySource } from "../../../../shared/queries/presentation/hooks/useQueriesBySource";

export const useBillQueries = (documentId: string | null) => {
  const { queries, loading, loadingMore, error, refetch, hasMore, loadMore } =
    useQueriesBySource("bill", documentId ? parseInt(documentId) : undefined);

  return { queries, loading, loadingMore, error, refetch, hasMore, loadMore };
};
